import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  // Modal styles (exact same as your inline styles)
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  inner: {
    padding: '20px',
  },
  
  modal: {
    maxWidth: '600px',
    width: '100%',
  },
  
  header: {
    backgroundColor: 'white',
    padding: '20px 24px',
    borderBottom: 'none',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  
  body: {
    padding: 0,
    backgroundColor: '#f8f9fa',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
  
  close: {
    color: '#868e96',
    '&:hover': {
      backgroundColor: '#f1f3f5',
    },
  },
  
  // Main content area
  mainContent: {
    padding: theme.spacing.xl,
    backgroundColor: '#f8f9fa',
  },
  
  // Form container
  formContainer: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  
  // Responsive flex containers
  responsiveFlex: {
    gap: 'md',
    marginBottom: 'md',
    flexDirection: 'column',
    
    [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
      flexDirection: 'row',
    },
  },
  
  // Flex item
  flexItem: {
    flex: 1,
  },
  
  // Button group
  buttonGroup: {
    gap: 'md',
    marginTop: 'xl',
    flexDirection: 'column',
    
    [`@media (min-width: ${theme.breakpoints.xs}px)`]: {
      flexDirection: 'row',
    },
  },
  
  // Cancel button styles
  cancelButton: {
    backgroundColor: '#f1f3f5',
    color: '#000000',
    border: 'none',
    fontFamily: 'Inter',
    borderRadius: "10px",
    fontWeight: 600,
    height: '44px',
    '&:hover': {
      backgroundColor: '#e9ecef',
    },
  },
  
  // Create button styles
  createButton: {
    backgroundColor: '#FFA94D',
    borderRadius: "10px",
    color: '#000000',
    fontFamily: 'Inter',
    fontWeight: 600,
    height: '44px',
    '&:hover': {
      backgroundColor: '#FF922B',
    },
  },
  
  // Subtle button styles (for URL label and Upload IMG)
  subtleButtonRoot: {
    color: '#313131',
    fontWeight: 400,
    fontSize: '12px',
    padding: '4px 8px',
    height: 'auto',
    '&:hover': {
      backgroundColor: '#e9ecef',
    },
  },
  
  subtleButtonLeftIcon: {
    marginRight: '4px',
  },
  
  // Delete image button
  deleteImageButton: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    width: '22px',
    height: '22px',
    padding: 0,
    borderRadius: '50%',
    border: '1px solid #dee2e6',
    color: '#495057',
    background: 'white',
    cursor: 'pointer',
    zIndex: 10,
  },
  
  // Textarea input
  textareaInput: {
    border: 'none',
    backgroundColor: '#f9fafb',
    padding: '12px',
    fontSize: '14px',
    fontFamily: 'Inter',
  },
}));